import { Pageheader } from './global-components/page-header';
import BlogSection from './section-components/blog-section';
import bgImage from '../assets/img/bg/Hyderabad.webp';

const HyderabadNews = () => {
    return (
        <div>
            <Pageheader headertitle="Hyderabad News" bgImage={bgImage} />
            <BlogSection category="hyderabad" />
        </div>
    );
};

export default HyderabadNews;
